import SvgEmailCircle from "assets/svgs/email-circle.svg";
import Button from "components/Button";

const CompleteSignUp = ({
  email,
  headerText,
  subHeaderText,
  onCloseModalSignup,
}) => {
  return (
    <>
      <h3 className="font-semibold mb-4 mt-8 text-center md:hidden text-xl">
        {headerText ? headerText : "Almost there!"}
        <br />
        Confirm your email address.
      </h3>
      <SvgEmailCircle className="block mx-auto" width="68" />

      {subHeaderText && <p className="mt-4 text-sm">{subHeaderText}</p>}
      <p className="mt-4 text-sm">
        We sent an email to <strong>{email}</strong>. <br />
        Please click the link inside to complete your registration.
      </p>
      <p className="mt-4 text-sm">
        If you don&apos;t see our email, check your promotions or SPAM folder.
      </p>
      <p className="bg-gray-100 mt-8 p-2 text-center text-xs">
        Contact{" "}
        <a className="font-semibold text-red hover:text-red-700">
          support@uncovered.com
        </a>{" "}
        if you have any issues or questions.
      </p>
      <Button
        className="mt-4 text-sm w-full"
        emphasis="primary"
        height="40"
        onClick={() => onCloseModalSignup()}
      >
        Close
      </Button>
    </>
  );
};

export default CompleteSignUp;
